import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { getAllData, getAllFilterData } from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { Col, Row, Container } from "react-bootstrap";

import successicon from "../../../assests/payments_icon/success.png";
import pendingicon from "../../../assests/payments_icon/pending.png";
import canceicon from "../../../assests/payments_icon/cancel.png";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const CryptoDetails = (props) => {
  const { selectedRecord } = props;
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [giftItem, setGiftItem] = useState("");
  const [claimDate, setClaimDate] = useState("");
  const [processDate, setProcessDate] = useState("");
  const [trackingCode, setTrackingCode] = useState("");
  const [status, setStatus] = useState(null);
  const [price, setPrice] = useState(null);
  const [giftCopy, setgiftCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);

  const userInfo = useSelector((state) => state.auth);

  const [pending, setPending] = useState(true);
  const [cancleShow, setCancleShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [pauseShow, setPauseShow] = useState(false);
  const [viewShow, setViewShow] = useState(false);

  const [rows, setRows] = useState([]);

  const [transData, setTransData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleViewClose = () => setViewShow(false);
  const handleCancleClose = () => setCancleShow(false);
  const handlePauseClose = () => setPauseShow(false);
  const handleCheckClose = () => setCheckShow(false);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const emptyRows = 0;

  useEffect(() => {
    paymentsData(selectedRecord.id_user);
  }, [selectedRecord]);

  useEffect(() => {
    if (editData) {
      setCustomerId(editData.customer_id || "");
      setGiftItem(editData.gift_item || "");
      setClaimDate(
        editData.claim_date
          ? moment(editData.claim_date).format("YYYY-MM-DD")
          : ""
      );
      setProcessDate(
        editData.process_date
          ? moment.utc(editData.process_date).format("YYYY-MM-DD")
          : ""
      );
      setTrackingCode(editData.tracking_code || "");
      setStatus(editData.status || "");
      setPrice(editData.price || "");
      setgiftCopy(editData.gift_copy || "");
      setTermConditions(editData.terms_condition || "");
    }
  }, [editData]);

  const paymentsData = async (userId) => {
    let url = `${
      endPoints.api.CRYPTO_TRANSACTION_BY_USERID
    }${userId}/${1}/${1000}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
  };

  const Approval = async (alldata) => {
    try {
      let url = `${endPoints.api.ALLOW_CRYPTO}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 1,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(selectedRecord.id_user);
        setCheckShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const Cancel = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 3,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(selectedRecord.id_user);
        setCancleShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const Hold = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: 2,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(selectedRecord.id_user);
        setPauseShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const closeView = () => {
    setViewShow(false);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Withdrawal Requests
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Username</TableCell>
                            <TableCell align="center">Name </TableCell>
                            <TableCell align="center">Email</TableCell>
                            <TableCell align="center">Email Check</TableCell>
                            <TableCell align="center">Transaction ID</TableCell>
                            <TableCell align="center">
                              Transaction Type
                            </TableCell>
                            <TableCell align="center">Trans Date</TableCell>
                            <TableCell align="center">Processed Date</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">
                              Withdrawal Status
                            </TableCell>

                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                              style={{
                                background: row.isDifferentEmail
                                  ? "#ec9999"
                                  : "",
                              }}
                            >
                              <TableCell align="center">
                                {row.id_user}
                              </TableCell>
                              <TableCell align="center">{row.login}</TableCell>

                              <TableCell align="center">
                                {row.name} {row.surname}
                              </TableCell>
                              <TableCell align="center">{row.email}</TableCell>
                              <TableCell align="center">
                                {row.isDifferentEmail ? "Different" : "Same"}
                              </TableCell>

                              <TableCell align="center">
                                {row.id_transaction}
                              </TableCell>
                              <TableCell align="center">
                                {/* {row.type == 24 ? "Corepay" : "Skrill"} */}
                                {"Crypto"}
                              </TableCell>
                              <TableCell align="center">
                                {moment
                                  .utc(row.insertion_time)
                                  .format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell align="center">
                                {row.status == 1 &&
                                  moment
                                    .utc(row.updated_on)
                                    .format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell align="center">
                                ${row.tamount}
                              </TableCell>
                              <TableCell align="center">
                                {row.transaction_status}
                              </TableCell>
                     
                              <TableCell
                                align="center"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="mrglft10"
                                  style={{
                                    background: "#0D3862",
                                    borderRadius: "8px",
                                  }}
                                  onClick={() => {
                                    setViewShow(true);
                                    setCreateData(true);
                                    setEditData(row);
                                  }}
                                >
                                  View
                                </Button>

                                {row.status == 1 || row.status == 3 ? (
                                  ""
                                ) : (
                                  <>
                                    <img
                                      src={successicon}
                                      style={{ height: "30px" }}
                                      onClick={() => {
                                        setCheckShow(true);
                                        setCreateData(true);
                                        setEditData(row);
                                      }}
                                    />
                                    {row.status == 2 ? (
                                      <img
                                        src={pendingicon}
                                        style={{
                                          height: "30px",
                                          opacity: "30%",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={pendingicon}
                                        style={{ height: "30px" }}
                                        onClick={() => {
                                          setPauseShow(true);
                                          setCreateData(true);
                                          setEditData(row);
                                        }}
                                      />
                                    )}

                                    <img
                                      src={canceicon}
                                      style={{ height: "30px" }}
                                      onClick={() => {
                                        setCancleShow(true);
                                        setCreateData(true);
                                        console.log("row", row);
                                        setEditData(row);
                                      }}
                                    />
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              className="hide-rows-per-page-options"
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              colSpan={12}
                              count={
                                rowsPerPage === -1 ? rows.length : totalcount
                              }
                              rowsPerPage={rowsPerPage}
                              page={page - 1}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={checkShow}
                      onHide={handleCheckClose}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Withdrawal Approval</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Approve this transaction?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                After approval, funds will be sent to the
                                payment provider.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#0A9B14",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Approval(editData);
                                }}
                              >
                                Approve Withdrawal
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={cancleShow}
                      onHide={handleCancleClose}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Withdrawal Cancellation</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Cancel this transaction?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                After cancellation funds will be returned to the
                                player’s account.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#ED0100",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Cancel(editData);
                                }}
                              >
                                Cancel Withdrawal
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={pauseShow}
                      onHide={handlePauseClose}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Place Withdrawal On Hold</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to put this transaction on
                                  Hold?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                This transaction will be held while you
                                investigate. You can return later to approve or
                                cancel.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#D66E05",
                                  border: "none",
                                }}
                                onClick={() => {
                                  Hold(editData);
                                }}
                              >
                                Put Withdrawal on Hold
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={viewShow}
                      onHide={handleViewClose}
                      size="xl"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header
                        closeButton
                        style={{ fontSize: "24px", fontWeight: "bold" }}
                      >
                        Withdrawal Details
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.id_user}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData.id_transaction}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer Name:</th>
                                    <td>{editData.name}</td>
                                    <th>Transaction Date:</th>
                                    <td>
                                      {moment
                                        .utc(editData.insertion_time)
                                        .format("YYYY-MM-DD")}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>User Name:</th>
                                    <td>{editData.login}</td>
                                    <th>Amount:</th>
                                    <td>${editData.tamount}</td>
                                  </tr>
                                  <tr>
                                    <th>Withdrawal Status:</th>
                                    <td>{editData.transaction_status}</td>
                                    <th>Transaction type:</th>
                                    <td>
                                      {/* {editData.type == 24
                                        ? "Corepay"
                                        : "Skrill"} */}
                                        {"Crypto"}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} className="text-center">
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{ width: "30%", marginTop: "20px" }}
                                onClick={closeView}
                              >
                                Close
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CryptoDetails;
